import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ReportSettingForm } from "./ReportSettingForm";

interface CreateReportSettingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export function CreateReportSettingModal({ isOpen, onClose, onSuccess }: CreateReportSettingModalProps) {
  const handleSuccess = () => {
    onSuccess();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Create Report Setting</DialogTitle>
          <DialogDescription>
            Create a new blacklist filter for Dorman adjusted margin report option months
          </DialogDescription>
        </DialogHeader>

        <ReportSettingForm
          mode="create"
          onSuccess={handleSuccess}
          onCancel={onClose}
          showCancelButton={true}
        />
      </DialogContent>
    </Dialog>
  );
}
